import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { ClientServicesService } from 'app/entities/details/services/client-services.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

@Component({
    selector: 'edit-description',
    templateUrl: './edit-description.component.html'
})

/**
 * Component for updating services/documents description.
 */
export class EditServicesDescriptionComponent {
    clientId: number;
    description: string;
    updatingDescription: boolean;
    isServicesDescription: boolean;
    serviceId: number;

    constructor(
        public dialogRef: MdDialogRef<any>,
        private clientServicesService: ClientServicesService,
        private snackBarService: SnackBarService) { }

    updateDescription() {
        this.updatingDescription = true;
        if (this.isServicesDescription) {
            this.updateServicesDescription();
        } else {
            this.updateDocumentsDescription();
        }
    }

    updateServicesDescription() {
        this.updatingDescription = true;
        const postOrgData = {
            'clientid': this.clientId,
            'servicedesc': this.description,
            'serviceid': this.serviceId
        };
        this.clientServicesService.updateServicesDescription(postOrgData)
            .subscribe(
            success => {
                this.updatingDescription = false;
                this.callSnackBarService(success);
                this.dialogRef.close(this.description);
            },
            err => {
                this.updatingDescription = false;
                this.callSnackBarService(err);
            }
            );
    }

    updateDocumentsDescription() {
        this.updatingDescription = true;
        const postOrgData = {
            'clientid': this.clientId,
            'documentdesc': this.description,
        };
        this.clientServicesService.updateDocumentsDescription(postOrgData)
            .subscribe(
            success => {
                this.updatingDescription = false;
                this.callSnackBarService(success);
                this.dialogRef.close(this.description);
            },
            err => {
                this.updatingDescription = false;
                this.callSnackBarService(err);
            }
            );
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.UPDATE_DESCRIPTION_SUCCESS,
            MessageService.UPDATE_DESCRIPTION_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/services/editdescription/edit-description.component.ts